import { Col, Container, Image, Row } from 'react-bootstrap';

import React from 'react';

export default function Header() {
  return (
    <Container fluid id="header-wrapper">
       <Row className="justify-content-center">
          <Col md={12} lg={8} xl={6}>
            
            <div className='pt-2 pb-2 text-center header-d'></div>
              
            </Col>
            </Row>
      {/* <Row className="justify-content-center">
        <Col xs={8} md={5} lg={4}>
          <Image
            src="https://resources.swmc.com/swmc-images/Homepage/New/SunWest41YearsofTrust-Blue.png"
            fluid
            alt="Sun West Mortgage Logo"
          />
        </Col>
      </Row>*/}
    </Container>
  );
}
